import React from 'react';
import { addSeconds, startOfToday, setMinutes, setHours, setSeconds } from 'date-fns';
import Input from '@creditflowresearch/uilib/Input';
import InputRange from '@creditflowresearch/uilib/Input/InputRange';
import {
  MAX_TIME_VALUE,
  MIN_TIME_VALUE,
} from './TimePicker/constants';
import TimePicker from './TimePicker/TimePicker';
import { takeDayTime } from './helpers';

import styles from './timePeriod.module.scss';
import IconClock from '@creditflowresearch/uilib/Icon/IconClock';

const defaultSelectedValue = { min: MIN_TIME_VALUE, max: MAX_TIME_VALUE };

function TimePeriod({ selectedValue = defaultSelectedValue, onFilterUpdate }) {
  const now = startOfToday();

  const setValue = (value, field) => {
    if (value[field] > 0 && value[field] <= MAX_TIME_VALUE && value.max > value.min) {
      onFilterUpdate(value);
    }
  };

  const onIncrement = (value: number, field: 'min' | 'max') => {
    setValue({ ...selectedValue, [field]: selectedValue[field] + value }, field);
  };

  const onDecrement = (value: number, field: 'min' | 'max') => {
    setValue({ ...selectedValue, [field]: selectedValue[field] - value }, field);
  };

  const onChangeCustomTimeInput = (value, field: 'min' | 'max') => {
    let updatedValue = addSeconds(now, selectedValue[field]);
    if (value.hours) {
      updatedValue = setHours(updatedValue, value.hours);
    }
    if (value.minutes) {
      updatedValue = setMinutes(updatedValue, value.minutes);
    }
    if (value.seconds) {
      updatedValue = setSeconds(updatedValue, value.seconds);
    }
    setValue({ ...selectedValue, [field]: takeDayTime(updatedValue) }, field);
  };

  const onChangeDateInput = (value, field) => {
    const time = takeDayTime(value);
    setValue({ ...selectedValue, [field]: time }, field);
  };

  return (
    <div className={ styles.filterRangeSlider }>
      <InputRange
        minValue={ MIN_TIME_VALUE }
        maxValue={ MAX_TIME_VALUE }
        onChange={ onFilterUpdate }
        value={ selectedValue }
      />

      <div className={ styles.dateTimePeriodWrp }>
        <div className={ styles.picker }>
          <TimePicker
            name="min"
            customInput={ (
              // @ts-ignore
              <Input
                icon={ IconClock }
                iconPosition="right"
                isNarrow
                isClearable={ false }
                name="startDateTimePeriodInput"
                dataTest="startDateTimePeriodInput"
                className={ styles.input }
                iconClassName={ styles.icon }
              />
            ) }
            placeholderText="Start time"
            selected={ addSeconds(now, selectedValue.min) }
            popperPlacement="bottom-start"
            usePortal
            dataTest="dateTimePeriodStartDatePicker"
            increment={ onIncrement }
            decrement={ onDecrement }
            onChangeCustomTimeInput={ onChangeCustomTimeInput }
            onChange={ onChangeDateInput }
          />
        </div>
        <div className={ styles.picker }>
          <TimePicker
            name="max"
            customInput={ (
              // @ts-ignore
              <Input
                icon={ IconClock }
                iconPosition="right"
                isNarrow
                isClearable={ false }
                name="endDateTimePeriodInput"
                dataTest="endDateTimePeriodInput"
                className={ styles.input }
                iconClassName={ styles.icon }
              />
            ) }
            placeholderText="End time"
            selected={ addSeconds(now, selectedValue.max) }
            popperPlacement="bottom-end"
            usePortal
            dataTest="dateTimePeriodEndDatePicker"
            increment={ onIncrement }
            decrement={ onDecrement }
            onChangeCustomTimeInput={ onChangeCustomTimeInput }
            onChange={ onChangeDateInput }
          />
        </div>
      </div>
    </div>
  );
}

export default TimePeriod;
